import type { ReviewTypeArray } from "@/constants";
import clsx from "clsx";
import { useMemo } from "react";
import { ReviewTypeLabelMap } from "@/constants";
import { Badge } from "@/components/ui/badge";

export function ReviewRequestTypeBadge({
  type,
  className: cn,
}: {
  type: (typeof ReviewTypeArray)[number];
  className?: string;
}) {
  const { className, text } = useMemo(() => {
    switch (type) {
      case "review":
        return {
          className: "bg-green-200 text-green-800",
          text: ReviewTypeLabelMap[type],
        };
      case "trial":
        return {
          className: "bg-purple-200 text-purple-800",
          text: ReviewTypeLabelMap[type],
        };
      case "detect":
        return {
          className: "bg-yellow-200 text-yellow-800",
          text: ReviewTypeLabelMap[type],
        };
    }
  }, [type]);

  return (
    <Badge className={clsx(className, cn, "cursor-default")}>
      <span>{text}</span>
    </Badge>
  );
}
